function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
// Limitless Imports
import CustomerDialogue from "../dialogues/customer-dialogue/CustomerDialogue";
import ExpertDialogue from "../dialogues/expert-dialogue/ExpertDialogue";
import SystemExpiryDialogue from "../dialogues/system-expiry-dialogue/SystemExpiryDialogue";
import SystemInfoDialogue from "../dialogues/system-info-dialogue/SystemInfoDialogue";
import SystemEmailInfoDialogue from "../dialogues/system-email-info-dialogue/SystemEmailInfoDialogue";
import TypingIndicator from "../dialogues/typing-indicator/TypingIndicator";
import SuggestedAnswerDialogueCarousel from "../dialogues/suggested-answer-dialogue-carousel/SuggestedAnswerDialogueCarousel";
import { withi18n } from "../hocs/i18n";
import CustomerAttachmentDialogue from "../dialogues/customer-dialogue/CustomerAttachmentDialogue";
import ExpertAttachmentDialogue from "../dialogues/expert-dialogue/ExpertAttachmentDialogue";
import SecureDataDialogue from "../dialogues/secure-data-dialogue/SecureDataDialogue";
class Conversation extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      preventScrolling: this.props.dialoguesVisible,
      firstLoad: true
    });
    _defineProperty(this, "scrollToBottom", () => {
      // "messagesAnchor" is an empty div at the end of the message list
      this.messagesAnchor.scrollIntoView({
        block: "end",
        behavior: "smooth"
      });
    });
    _defineProperty(this, "handleSAFullScreen", isFullScreen => {
      this.props.dialoguesVisible(isFullScreen);
      if (isFullScreen === true) {
        setTimeout(() => this.messagesAnchor.scrollIntoView({
          block: "end",
          behavior: "instant"
        }), 10);
      }
    });
    _defineProperty(this, "updateDateHeader", (dialogue, index) => {
      const {
        classes
      } = this.props;
      if (dialogue.dateCaption) {
        return /*#__PURE__*/React.createElement("div", {
          key: dialogue.dialogueId,
          className: classes.messageContainer
        }, /*#__PURE__*/React.createElement(Typography, {
          className: classes.dayText,
          component: "div"
        }, this.props.t(dialogue.dateCaption)), this.renderDialogue(dialogue, index));
      } else {
        return this.renderDialogue(dialogue, index);
      }
    });
    _defineProperty(this, "renderDialogue", (dialogue, index) => {
      const {
        clearSuggestedAnswers,
        dialoguesVisibility,
        logger,
        isHistoryMessage,
        isReported,
        message,
        t
      } = this.props;
      const {
        firstLoad
      } = this.state;
      let shouldAnimate = !firstLoad;
      //is this the last Dialogue?
      const lastDialogue = index === this.props.dialogues.length - 1 ? true : false;
      //if we're a history message and the last dialogue, don't animate
      shouldAnimate = lastDialogue && isHistoryMessage && firstLoad ? false : shouldAnimate;
      //is this the first Dialogue?
      const firstDialogue = index === 0 ? true : false;
      logger.debug(`${index}, ${this.props.dialogues.length - 1} last: ${lastDialogue}, first: ${firstDialogue}  history message? ${isHistoryMessage}, shouldAnimate: ${shouldAnimate}, firstLoad: ${firstLoad}`);
      if (dialogue.origin === "customer") {
        if (dialoguesVisibility) {
          if (dialogue.type === "attachment") {
            return /*#__PURE__*/React.createElement(CustomerAttachmentDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: !firstDialogue && lastDialogue && shouldAnimate
            });
          } else {
            return /*#__PURE__*/React.createElement(CustomerDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: !firstDialogue && lastDialogue && shouldAnimate
            });
          }
        }
      } else if (dialogue.origin === "system" && dialogue.type === "information") {
        return dialoguesVisibility && /*#__PURE__*/React.createElement(SystemInfoDialogue, {
          body: dialogue.body,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate
        });
      } else if (dialogue.origin === "system" && dialogue.type === "emailInfo") {
        return /*#__PURE__*/React.createElement(SystemEmailInfoDialogue, {
          body: dialogue.body,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate,
          message: message
        });
      } else if (dialogue.origin === "system" && dialogue.type === "expiry") {
        return dialoguesVisibility && /*#__PURE__*/React.createElement(SystemExpiryDialogue, {
          dialogue: dialogue,
          body: dialogue.body,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate
        });
      } else if (dialogue.origin === "system" && dialogue.type === "reminder") {
        return /*#__PURE__*/React.createElement(SystemInfoDialogue, {
          body: dialogue.body,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate
        });
      } else if (dialogue.origin === "expert" && dialogue.type === "suggestedAnswer") {
        //only show suggested answers if they're the last dialogue
        if (!lastDialogue) {
          return /*#__PURE__*/React.createElement("div", {
            key: 1
          });
        }
        return /*#__PURE__*/React.createElement(SuggestedAnswerDialogueCarousel, {
          key: dialogue.created,
          dialogue: dialogue,
          handleSuggestedAnswerSelection: this.props.handleSuggestedAnswerSelection,
          handleFullScreen: this.handleSAFullScreen,
          unmount: clearSuggestedAnswers,
          message: message
        });
      } else if (dialogue.origin === "expert" && dialogue.type === "suggestedEscalation") {
        //no suggested escalation
        return /*#__PURE__*/React.createElement("div", {
          key: 2
        });
      } else if (dialogue.origin === "expert" && dialogue.type === "secureData") {
        //secure data request
        return /*#__PURE__*/React.createElement(SecureDataDialogue, {
          t: t,
          dialogue: dialogue,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate,
          message: message
        });
      } else {
        if (dialoguesVisibility) {
          if (dialogue.type === "attachment") {
            return /*#__PURE__*/React.createElement(ExpertAttachmentDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: lastDialogue && shouldAnimate,
              isReported: isReported,
              message: message
            });
          } else {
            return /*#__PURE__*/React.createElement(ExpertDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: lastDialogue && shouldAnimate,
              isReported: isReported,
              message: message
            });
          }
        }
      }
      return /*#__PURE__*/React.createElement("div", {
        key: 3
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    const newState = {};
    if (nextProps.dialoguesVisible !== this.props.dialoguesVisible) {
      newState.preventScrolling = nextProps.dialoguesVisible;
    }
    if (this.props.dialogues.length > 0 && this.state.firstLoad) {
      newState.firstLoad = false;
    }
    if (newState) {
      this.setState(newState);
    }
  }
  componentDidUpdate() {
    //when the component receives new messages, scroll to the bottom
    if (this.props.scrollOnLoad) {
      this.scrollToBottom();
    }
  }
  render() {
    const {
      dialogues,
      typing,
      claimer,
      classes,
      t,
      poweredByEnabled,
      message
    } = this.props;
    const {
      preventScrolling
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: `${classes.conversationContainer} ${preventScrolling && classes.preventScrolling}`,
      id: "limitless-allow-scroll"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.messageList
    }, dialogues.map((dialogue, index) => {
      return this.updateDateHeader(dialogue, index);
    })), typing && /*#__PURE__*/React.createElement(TypingIndicator, {
      claimer: claimer,
      message: message
    }), poweredByEnabled && /*#__PURE__*/React.createElement(Typography, {
      variant: "caption",
      align: "center",
      className: classes.poweredBy,
      component: "div"
    }, t("Powered by Limitless")), /*#__PURE__*/React.createElement("div", {
      style: {
        float: "left",
        clear: "both"
      },
      ref: el => {
        this.messagesAnchor = el;
      }
    }));
  }
}
const styles = theme => ({
  conversationContainer: {
    height: "100%",
    position: "relative",
    overflow: "auto",
    backgroundImage: `url(${theme.background.image})`,
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat"
  },
  preventScrolling: {
    overflowY: "none"
  },
  messageList: {
    boxSizing: "border-box",
    margin: "auto 0 0",
    padding: "0",
    width: "100%",
    minHeight: "calc(100% - 30px)"
  },
  messageListProgress: {
    alignItems: "center",
    background: "#fff",
    borderRadius: "14px",
    fontSize: "13px",
    lineHeight: "1.333",
    marginBottom: "10px",
    padding: "11px 10px",
    marginRight: "33%",
    color: "white",
    textAlign: "center"
  },
  messageContainer: {
    width: "100%",
    paddingTop: "10px"
  },
  hrstyle: {
    position: "relative",
    width: "100%",
    marginTop: "10px",
    paddingTop: "0px",
    borderTopColor: "black",
    borderTopStyle: "hidden",
    borderTopWidth: "1px"
  },
  dayText: {
    position: "relative",
    margin: "0px auto",
    textAlign: "center",
    color: theme.palette.contrast.text
  },
  poweredBy: {
    color: theme.palette.contrast.text,
    paddingBottom: 10
  }
});
export default withStyles(styles)(withi18n(Conversation, "Conversation"));
Conversation.propTypes = {
  typing: PropTypes.bool,
  claimer: PropTypes.string,
  dialogues: PropTypes.array,
  handleSuggestedAnswerSelection: PropTypes.func,
  isHistoryMessage: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  logger: PropTypes.object.isRequired,
  clearSuggestedAnswers: PropTypes.bool.isRequired,
  dialoguesVisible: PropTypes.func.isRequired,
  dialoguesVisibility: PropTypes.bool.isRequired,
  scrollOnLoad: PropTypes.bool,
  poweredByEnabled: PropTypes.bool,
  isReported: PropTypes.bool,
  message: PropTypes.object.isRequired
};
Conversation.defaultProps = {
  scrollOnLoad: true,
  poweredByEnabled: false,
  isReported: false
};